<template>
  <b-row>
    <b-col cols="12" class="container min-vh-100">
      <ValidationObserver ref="form">
        <b-card class="w-100 h-100">
          <b-row>
            <b-col cols="12" md="12">
              <ValidationProvider
                name="ชื่อกลุ่มอนุกรรมการ"
                v-slot="{ errors }"
              >
                <b-form-group label="ชื่อกลุ่มอนุกรรมการ" label-for="name">
                  <b-form-input
                    id="name"
                    v-model="model.name"
                    placeholder="กรุณากรอก ชื่อกลุ่มอนุกรรมการ"
                  />
                </b-form-group>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider></b-col
            >

            <!-- <b-col cols="12" md="3">
              <ValidationProvider
                rules="required"
                name="ลำดับการแสดงผล"
                v-slot="{ errors }"
              >
                <b-form-group label="ลำดับการแสดงผล" label-for="sortOrder">
                  <template v-slot:label>
                    ลำดับการแสดงผล <span class="text-danger">*</span>
                  </template>
                  <b-form-input
                    id="sortOrder"
                    v-model="model.sortOrder"
                    placeholder="กรุณากรอก ลำดับการแสดงผล"
                  />
                </b-form-group>
                <span class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider></b-col
            > -->

            <b-col cols="12" class="mb-5">
              <b-form-group label="สถานะการใชข้งาน">
                <b-form-radio-group
                  id="isActive"
                  v-model="model.isActive"
                  :options="activeOptions"
                  name="radio-is-active"
                ></b-form-radio-group>
              </b-form-group>
            </b-col>

            <b-col cols="12" class="d-flex justify-content-between">
              <b-button variant="secondary" @click="onCancelBtnClicked">
                ยกเลิก
              </b-button>
              <b-button variant="primary" @click="onSubmitBtnClicked">
                บันทึกข้อมูล
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </ValidationObserver>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormTextarea,
  BCard,
  BFormRadio,
  BTab,
  BTabs,
  BButton,
  BFormInput,
  BFormGroup,
  BFormRadioGroup,
  BFormFile,
  BOverlay,
} from "bootstrap-vue";

import BCardActions from "@/@core/components/b-card-actions/BCardActions.vue";

import * as mediateDirectorGroupStore from "@/store/api/mediate-director/group.js";
import * as userData from "@/auth/localStorageUtils.js";

import VueSelect from "vue-select";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: ["", null, undefined].indexOf(value) === -1,
    };
  },
  message: "กรุณากรอก{_field_}",
  computesRequired: true,
});

export default {
  components: {
    BButton,
    BFormRadio,
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BTab,
    BTabs,
    BFormInput,
    BFormGroup,
    BFormRadioGroup,
    BFormFile,
    BOverlay,
    ValidationObserver,
    ValidationProvider,
    VueSelect,
  },
  data() {
    return {
      model: {
        isActive: true,
      },
      activeOptions: [
        { text: "ใช้งาน", value: true },
        { text: "ไม่ใช้งาน", value: false },
      ],
    };
  },
  created() {
    const _this = this;
    if (this.$route.query.id == null) {
    } else {
      const id = this.$route.query.id;
      this.getById(id);
    }
  },
  methods: {
    getById(id) {
      const _this = this;

      mediateDirectorGroupStore
        .getById(id)
        .then((response) => {
          _this.model = response.data.data;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onSubmitBtnClicked() {
      const _this = this;

      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }

        this.$swal({
          title: "ยืนยันการบันทึกข้อมูล?",
          text: "",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "บันทึก",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-primary ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            _this.model.updateBy = userData.userId();
            mediateDirectorGroupStore
              .updateItem(_this.model)
              .then((response) => {
                if (response.data.success === true) {
                  _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });

                  window.open(
                    _this.$router.resolve({
                      name: "MediateDirectorGroup",
                    }).href,
                    "_self"
                  );
                } else {
                  _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                    title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                    variant: "danger",
                    solid: false,
                  });
                }
              })
              .catch((error) => {
                console.log("error", error);
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                  title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                  variant: "danger",
                  solid: false,
                });
              });
          }
        });
      });
    },
    onCancelBtnClicked() {
      window.open(
        this.$router.resolve({ name: "MediateDirectorGroup" }).href,
        "_self"
      );
    },
    selectOnInput() {
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
